var map = {
	"./live/detail.vue": "ACYG",
	"./live/list.vue": "qEyW",
	"./login.vue": "Luci"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G8Cn";


//////////////////
// WEBPACK FOOTER
// ./src/pages \.vue$
// module id = G8Cn
// module chunks = 1